const LogoIcon = () => (
  <img
    width="85%"
    alt="daimler-icon"
    src="/daimler-truck-two-line-white.svg"
    style={{ marginLeft: '6px' }}
  />
);

export default LogoIcon;
